module.exports = __webpack_public_path__ + "static/img/a6980d1d.c10.b1a09d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/a6980d1d.c10.jpg
// module id = S0Dm
// module chunks = 2